import { createContext, useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import useLocalStorage from "../hooks/useLocalStorage";

export const CompanyContext = createContext({});

export const CompanyProvider = ({ children }: any) => {
  const [companyLoader, setCompanyLoader] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [company, setCompany] = useLocalStorage<any>("company");

  useEffect(() => {
    if (company && company.id) {
      setSelectedCompany(company);
      axiosInstance.defaults.headers.common["company"] = company.id;
    } else {
      setSelectedCompany({});
      delete axiosInstance.defaults.headers.common["company"];
    }
    setCompanyLoader(false);
  }, [company]);

  const handleChangeCompany = (value: any) => {
    setSelectedCompany(value);
    if (value && value.id) {
      axiosInstance.defaults.headers.common["company"] = value.id;
    } else {
      delete axiosInstance.defaults.headers.common["company"];
    }
    setCompany(value);
  };

  return (
    <CompanyContext.Provider value={{ selectedCompany, handleChangeCompany, companyLoader }}>
      {children}
    </CompanyContext.Provider>
  );
};
